/* eslint-disable no-param-reassign */
function doScrollTo(element, offset) {
  const bodyRect = document.body.getBoundingClientRect().top;
  const header = document.querySelector('.page-header');
  const headerHeight = header?.getBoundingClientRect().height;
  const isHeaderShown = header.classList.contains('-is-hidden');

  const elementRect = element?.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: isHeaderShown ? offsetPosition - headerHeight : offsetPosition,
    behavior: 'smooth',
  });
}

export default class Slider {
  init() {
    this.cardsCounter = 1;
    this.cardsCounterLike = 0;
    this.cardsCounterReject = 0;
    this.numOfCards = 5;
    this.decisionVal = 80;
    this.pullDeltaX = 0;
    this.deg = 0;
    this.startX = 0;

    this.animationSpeed = 400;

    this.isDragging = false;
    this.isDesktop = window.matchMedia('(min-width: 1200px)').matches;

    this.card = undefined;
    this.cardReject = undefined;
    this.cardLike = undefined;

    this.matchModule = document.querySelector('.match-module');
    if (!this.matchModule) return;

    this.matchResult = document.querySelector('.match-result');
    this.cardsContainer = this.matchModule.querySelector('.cards');

    this.onStart = this.onStart.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onEnd = this.onEnd.bind(this);
    this.onLikeClick = this.onLikeClick.bind(this);
    this.onRejectClick = this.onRejectClick.bind(this);
    this.showResult = this.showResult.bind(this);
    this.onNewStartClick = this.onNewStartClick.bind(this);

    this.matchResult.querySelectorAll('.link').forEach((link) => {
      link.addEventListener('click', this.onNewStartClick);
    });

    this.cardsContainer.querySelectorAll('.match-card:not(.-swiped)').forEach((card) => {
      card.querySelector('.button.-like').addEventListener('click', this.onLikeClick);
      card.querySelector('.button.-reject').addEventListener('click', this.onRejectClick);
      card.addEventListener('mousedown', this.onStart);
      card.addEventListener('touchstart', this.onStart);
    });
  }

  onStart(event) {
    if (this.isDragging) return;
    if (event.button === 2) return; // prevent drag on right mouseclick

    this.card = event.currentTarget;
    this.cardReject = this.card.querySelector('.choice.-reject');
    this.cardLike = this.card.querySelector('.choice.-like');
    this.startX = event.pageX || event.touches[0].pageX;

    document.addEventListener('mousemove', this.onMove);
    document.addEventListener('touchmove', this.onMove);
    document.addEventListener('mouseup', this.onEnd);
    document.addEventListener('touchend', this.onEnd);
  }

  onMove(event) {
    const x = event.pageX || event.touches[0].pageX;
    this.pullDeltaX = (x - this.startX);

    if (!this.pullDeltaX) return; // prevents from rapid click events

    this.dragCard();
  }

  onEnd() {
    document.removeEventListener('mousemove', this.onMove);
    document.removeEventListener('touchmove', this.onMove);
    document.removeEventListener('mouseup', this.onEnd);
    document.removeEventListener('touchend', this.onEnd);

    if (!this.pullDeltaX) return; // prevents from rapid click events

    this.releaseCard();
  }

  dragCard() {
    this.isDragging = true;
    this.deg = this.pullDeltaX / 10;

    if (this.isDesktop) {
      if (this.pullDeltaX >= 0) {
        this.card.style.transform = `translate(${this.pullDeltaX}px, ${-this.pullDeltaX}px) rotate(${this.deg}deg)`;
      } else {
        this.card.style.transform = `translate(${this.pullDeltaX}px, ${-this.pullDeltaX}px) rotate(${this.deg}deg)`;
      }
    } else {
      this.card.style.transform = `translateX(${this.pullDeltaX}px) rotate(${this.deg}deg)`;
    }

    this.card.classList.add('-current');

    this.infoTextYes = this.card.querySelector('.info.-yes');
    this.infoTextNo = this.card.querySelector('.info.-no');
    this.infoTextYes.style.display = 'none';
    this.infoTextNo.style.display = 'none';

    this.icon = this.card.querySelector('.choice.-like');
    this.icon.classList.remove('-bling');

    if (this.pullDeltaX >= (this.decisionVal)) {
      this.infoTextYes.style.display = 'block';
      this.icon.classList.add('-bling');
    } else if (this.pullDeltaX <= (-this.decisionVal)) {
      this.infoTextNo.style.display = 'block';
    }

    const opacity = this.pullDeltaX / 100;
    const rejectOpacity = (opacity >= 0) ? 0 : Math.abs(opacity);
    const likeOpacity = (opacity <= 0) ? 0 : opacity;

    this.cardLike.style.opacity = likeOpacity;
    this.cardReject.style.opacity = rejectOpacity;

    this.card.querySelectorAll('.button').forEach((button) => {
      if (opacity > 0) {
        button.style.opacity = 1 - opacity;
      } else {
        button.style.opacity = 1 + opacity;
      }
    });
  }

  releaseCard() {
    if (this.pullDeltaX >= this.decisionVal) {
      this.doLike();
    } else if (this.pullDeltaX <= -this.decisionVal) {
      this.doReject();
    }

    if (Math.abs(this.pullDeltaX) < this.decisionVal) {
      this.card.classList.add('-reset');

      this.doCleanup();
    }
  }

  finishSwipe() {
    this.card.classList.add('-swiped');

    setTimeout(() => {
      this.card.classList.add('-checked');
      this.card.classList.remove('-swiped', '-to-left', '-to-right', '-current');
      this.cardsCounter += 1;
    }, this.animationSpeed);

    this.doCleanup();
  }

  onLikeClick() {
    if (this.isDragging) return;

    this.doLike();
  }

  doLike() {
    this.infoTextYes = this.card.querySelector('.info.-yes');
    this.infoTextNo = this.card.querySelector('.info.-no');

    this.infoTextNo.style.display = 'none';
    this.infoTextYes.style.display = 'block';

    this.icon = this.card.querySelector('.choice.-like');
    this.icon.classList.add('-bling');

    this.card.classList.add('-to-right', '-current');
    this.card.querySelectorAll('.button').forEach((button) => {
      button.style.opacity = 0;
    });

    this.cardsCounterLike += 1;

    this.finishSwipe();
  }

  onRejectClick() {
    if (this.isDragging) return;

    this.doReject();
  }

  doReject() {
    this.infoTextYes = this.card.querySelector('.info.-yes');
    this.infoTextNo = this.card.querySelector('.info.-no');

    this.infoTextNo.style.display = 'block';
    this.infoTextYes.style.display = 'none';

    this.card.classList.add('-to-left', '-current');
    this.card.querySelectorAll('.button').forEach((button) => {
      button.style.opacity = 0;
    });

    this.cardsCounterReject += 1;

    this.finishSwipe();
  }

  doCleanup() {
    setTimeout(() => {
      this.card.style = null;
      this.card.classList.remove('-reset', '-current');
      this.card.querySelectorAll('.choice').forEach((el) => {
        el.style = null;
      });

      this.pullDeltaX = 0;
      this.isDragging = false;
    }, this.animationSpeed);

    this.card.querySelectorAll('.button').forEach((button) => {
      button.style.opacity = 1;
    });

    if (this.cardsCounter === this.numOfCards) {
      this.showResult();
    }
  }

  showResult() {
    const maybe = this.matchResult.querySelector('.maybe');
    const yes = this.matchResult.querySelector('.yes');
    const no = this.matchResult.querySelector('.no');

    this.marginTopMatchResult = window.getComputedStyle(this.matchResult).marginTop;
    this.offset = parseFloat(this.marginTopMatchResult);

    setTimeout(() => {
      this.matchModule.style.display = 'none';

      if (this.cardsCounterLike === 2) {
        maybe.style.display = 'flex';
      } else if (this.cardsCounterLike > 2) {
        yes.style.display = 'flex';
      } else {
        no.style.display = 'flex';
      }

      doScrollTo(this.matchResult, this.offset);

      yes.querySelector('.image').classList.add('-fade-in');
      no.querySelector('.image').classList.add('-fade-in');
      maybe.querySelector('.image').classList.add('-fade-in');
    }, this.animationSpeed);
  }

  onNewStartClick() {
    this.matchResult.querySelector('.maybe').style.display = 'none';
    this.matchResult.querySelector('.yes').style.display = 'none';
    this.matchResult.querySelector('.no').style.display = 'none';

    this.matchModule.style.display = 'block';
    this.cardsContainer.querySelectorAll('.-checked').forEach((card) => card.classList.remove('-checked'));
    this.cardsCounter = 1;
    this.cardsCounterLike = 0;
    this.cardsCounterReject = 0;

    this.marginTopMatchModule = window.getComputedStyle(this.matchModule).marginTop;
    this.offset = parseFloat(this.marginTopMatchModule) / 2;

    doScrollTo(this.matchModule, this.offset);
  }
}
